import { render, staticRenderFns } from "./RptDeliveryCustomer.vue?vue&type=template&id=85294e30&scoped=true"
import script from "./RptDeliveryCustomer.vue?vue&type=script&lang=js"
export * from "./RptDeliveryCustomer.vue?vue&type=script&lang=js"
import style0 from "./RptDeliveryCustomer.vue?vue&type=style&index=0&id=85294e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85294e30",
  null
  
)

export default component.exports